import React from 'react';

import { Box, Center, HStack } from '@chakra-ui/react';
import dayjs from 'dayjs';
import map from 'lodash/map';

import { CustomTooltip } from 'components/DataDisplay/Tooltip/CustomTooltip';
import { getIcon } from 'components/Icons/Components';

const integrationDisplayNames: Record<string, string> = {
  email: 'Email',
  jira: 'Jira',
  servicenow: 'Servicenow',
  slack: 'Slack',
  teams: 'Teams',
};

export const renderSlaViolation = ticket => {
  let due_date: any = ticket?.due_date;
  if (!!due_date) due_date = dayjs(ticket?.due_date);
  // A ticket violates its SLA only once it is past its due date (the check was
  // inverted, flagging overdue tickets as "No").
  const noSlaViolation = !due_date || !dayjs().isAfter(due_date);
  return (
    <HStack>
      <Box>{noSlaViolation ? 'No' : 'Yes'}</Box>
      <Box
        boxSize={3.5}
        borderRadius={4}
        bg={noSlaViolation ? 'green.300' : 'critical'}
      />
    </HStack>
  );
};

export const getAlertStatusMapping = status => {
  switch (status) {
    case 'todo':
    case 'Todo':
      return 'To Do';
    case 'in_progress':
    case 'in progress':
      return 'In Progress';
    case 'resolved':
      return 'Resolved';
    case 'snoozed':
      return 'Snoozed';
    default:
      return status;
  }
};

export const renderAlertDrawerIntegrations = integrations => {
  return (
    <HStack>
      {map(integrations, o => (
        <CustomTooltip label={integrationDisplayNames[o] ?? o} key={o}>
          <Box boxSize={5}>
            <Center>{getIcon(o)}</Center>
          </Box>
        </CustomTooltip>
      ))}
    </HStack>
  );
};

export const vmPortNames = [
  'access_ports',
  'db_ports',
  'forbidden_ports',
  'non_standard_ports',
  'web_app_ports',
];

export const getPortName = type => {
  switch (type) {
    case 'access_ports':
      return 'Access';
    case 'db_ports':
      return 'Database';
    case 'forbidden_ports':
      return 'Deprecated';
    case 'non_standard_ports':
      return 'Non-Standard';
    case 'web_app_ports':
      return 'Web Application';
  }
  return type;
};
